import apiService from '../Api'

export class RequestNoteService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async list(requestId: number): Promise<any> {
    return apiService.get(`/requests/notes/${requestId}`).then((response) => response.data)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async create(requestId: number, note: string): Promise<any> {
    return apiService.post('/requests/notes', { request_id: requestId, note }).then((response) => response.data)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async update(id: number, note: string): Promise<any> {
    return apiService.put(`/requests/notes/${id}`, { note }).then((response) => response.data)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async destroy(id: number): Promise<any> {
    return apiService.delete(`/requests/notes/${id}`).then((response) => response.data)
  }
}
